export default __webpack_public_path__ + "static/lb-08-f33dbdf800b91e96622f4a3ce579206d.webp";